<!-- src/layouts/AppLayout.vue -->
<template>
  <router-view />
  <!--<FloatingChat :receiverId="2" :userId="1" />-->
</template>

<script>
/*import FloatingChat from "@/components/FloatingChat.vue";

export default {
  components: {
    FloatingChat,
  },
};
*/
</script>
